import { render, staticRenderFns } from "./general-switch.vue?vue&type=template&id=3636752c&scoped=true&"
import script from "./general-switch.vue?vue&type=script&lang=js&"
export * from "./general-switch.vue?vue&type=script&lang=js&"
import style0 from "./general-switch.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./general-switch.vue?vue&type=style&index=1&id=3636752c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636752c",
  null
  
)

export default component.exports